import { formatDate } from "../utils/format-utils";
import ServicePlan from "./ServicePlan";
import Client from "./Client";


export default class Plan {
  planId?: number | null;
  clientId?: number | null;
  client?: Client | null;
  planStartDate?: Date | null;
  planMeetingDate?: Date | null;
  closureDate?: Date | null;
  planTypeId?: number | null;
  planType?: string | null;
  isSummerSemesterIncluded?: boolean | null;
  languageId?: number | null;
  servicePlans?: ServicePlan[] | null;

  public constructor(params: Plan = {} as Plan) {
    let {
      planId = 0,
      clientId = null,
      client = null,
      planStartDate = null,
      planMeetingDate = null,
      closureDate = null,
      planTypeId = null,
      planType = null,
      isSummerSemesterIncluded = null,
      languageId = null,
      servicePlans = null,
    } = params;
    this.planId = planId;
    this.clientId = clientId;
    this.client = client && new Client(client);
    this.planStartDate = planStartDate;
    this.planMeetingDate = planMeetingDate;
    this.closureDate = closureDate;
    this.planTypeId = planTypeId;
    this.planType = planType;
    this.isSummerSemesterIncluded = isSummerSemesterIncluded;
    this.languageId = languageId;
    this.servicePlans =
      servicePlans && servicePlans.map((item) => new ServicePlan(item));
  }
  get formattedStartDate() {
    return formatDate(this.planStartDate);
  }
  get formattedEndDate() {
    return formatDate(this.closureDate);
  }
  get isActive() {
    return this.closureDate == null || this.closureDate >= new Date();
  }
}
